<div class="lcl-origin-warehouse">
  <div class="lcl-origin-warehouse__note" *ngIf="shipment?.trackingState < TRACKING_STATES.AT_ORIGIN_WAREHOUSE">
    <span>
      {{
        (isImporter ? "LCL_SHIPMENT.SHIPMENT.ORIGIN_WAREHOUSE_IMPORTER_NOTE" : "LCL_SHIPMENT.SHIPMENT.ORIGIN_WAREHOUSE_SHIPPER_NOTE")
          | translate
      }}
    </span>
  </div>

  <div class="row">
    <div
      class="col-12 lcl-origin-warehouse__address"
      [ngClass]="{
        'col-lg-4': shipment?.trackingState === TRACKING_STATES.BOOKING_PLACED,
        'col-lg-6': shipment?.trackingState === TRACKING_STATES.AT_ORIGIN_WAREHOUSE
      }"
    >
      <span class="lcl-origin-warehouse__address-label">{{ "LABELS.ADDRESS" | translate }}</span>
      <span class="lcl-origin-warehouse__address-info">{{ shipment?.voyage?.originContainerFreightStorage?.displayName }}</span>
      <span class="lcl-origin-warehouse__address-info secondary">
        <address-details
          [address]="shipment?.voyage?.originContainerFreightStorage?.address"
          *ngIf="!!shipment?.voyage?.originContainerFreightStorage?.address"
        ></address-details>
      </span>
    </div>

    <div class="col-12 col-lg-4 lcl-origin-warehouse__hours" *ngIf="shipment?.trackingState === TRACKING_STATES.BOOKING_PLACED">
      <span class="lcl-origin-warehouse__hours-label">{{ "LABELS.OPENING_HOURS" | translate }}</span>
      <span class="lcl-origin-warehouse__hours-info">{{ shipment?.voyage?.originContainerFreightStorage?.openingHours }}</span>
    </div>

    <div
      class="col-12 lcl-origin-warehouse__cut-off"
      [ngClass]="{
        'col-lg-4': shipment?.trackingState === TRACKING_STATES.BOOKING_PLACED,
        'col-lg-6': shipment?.trackingState > TRACKING_STATES.BOOKING_PLACED
      }"
      *ngIf="shipment?.trackingState < TRACKING_STATES.IN_TRANSIT"
    >
      <span class="lcl-origin-warehouse__cut-off-label">{{ "LCL_SHIPMENT.SHIPMENT.CUT_OFF_DATE" | translate }}</span>
      <span class="lcl-origin-warehouse__cut-off-info">{{ shipment?.voyage?.warehouseCutoff | customDateByUtc }}</span>
      <span
        class="lcl-origin-warehouse__cut-off-difference"
        [ngClass]="{ error: daysBetween <= 0 }"
        *ngIf="shipment?.trackingState < TRACKING_STATES.AT_ORIGIN_WAREHOUSE"
      >
        {{ getDifferenceDays() }}
      </span>
      <span class="lcl-origin-warehouse__cut-off-difference" *ngIf="shipment?.trackingState >= TRACKING_STATES.AT_ORIGIN_WAREHOUSE">
        {{ "LABELS.ORIGIN_WAREHOUSE_CUTOFF_ARRIVED_AT" | translate : { date: shipment?.arrivalToOriginWarehouseDate | customDateByUtc } }}
      </span>
    </div>
  </div>
</div>
